import React from "react";

// Stylized opening quotation mark used above pull-quotes
const QuoteMark = ({ color = "#A33B35", size = 56 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width={size}
      height={size}
      aria-hidden="true"
      className="quote-mark"
    >
      <path
        d="M6 28 C 6 18, 11 10, 19 8 L 20 11 C 14 13, 11 18, 11 22 L 18 22 L 18 32 L 6 32 Z M22 28 C 22 18, 27 10, 35 8 L 36 11 C 30 13, 27 18, 27 22 L 34 22 L 34 32 L 22 32 Z"
        fill={color}
      />
    </svg>
  );
};

export default QuoteMark;
